import axios from 'axios'

export default axios.create({baseURL: 'https://search-recipes-app-default-rtdb.firebaseio.com/'})
